
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { BoardIVO, BoardOVO, BoardReplyOVO, BoardReplyIVO } from '@/views/biz/board/vo/BoardVO'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { FileMstVO } from "@/views/bizcommon/file/vo/FileVO";
import Constants from '@/constants'
import CommonUtils from '@/common-utils'
import axios from 'axios'

@Component
export default class BoardDetail extends Vue {
  @Prop() bmNo!: string;

  currentBmNo = '';
  boardReplyLoading = false;
  boardBottomSheet = {opened: false, item: {} as BoardOVO};
  replyBottomSheet = {opened: false, item: {} as BoardReplyOVO};
  currentReply = {} as BoardReplyOVO;

  member: MemberVO = {} as MemberVO;

  boardOVO: BoardOVO = {} as BoardOVO
  boardReplyList: Array<BoardReplyOVO> = {} as Array<BoardReplyOVO>

  nextBoard: BoardOVO = {} as BoardOVO
  preBoard: BoardOVO = {} as BoardOVO

  isReplyForm = false;
  

  // 앱에서 작성한 글이면 이미지 테이블에서 조회된 이미지 노출
  get getImagesByWriteApp(): Array<FileMstVO> {
    if(!this.boardOVO.bmContent) {
      return [];
    }
    // 웹에서 쓴거라면
    if(this.boardOVO.bmContent.indexOf('<img') != -1) {
      return [];
    }

    return this.boardOVO.images;
  }

  // 첨부파일 조회
  get getAttachFiles(): Array<FileMstVO> {
    return this.boardOVO.attachFiles;
  }

  // 댓글 새로고침
  refreshBoardReply(): void {
    this.boardReplyLoading = true;
    axios.get(`board/reply/${this.currentBmNo}`)
    .then(r => {
      this.boardReplyList = r.data;
      this.boardReplyLoading = false;
      this.$toast('댓글을 업데이트 했습니다');
    })
  }

  // 게시글 조회
  getBoard(bmNo: string): void {
    axios.get(`board/${this.currentBmNo}`)
    .then(r => {
      this.boardOVO = r.data;

      this.nextBoard = {} as BoardOVO
      this.preBoard = {} as BoardOVO

      // 컬럼명이 바뀜.ㅠㅠ
      const pre = this.boardOVO.nextBmNo && (this.boardOVO.nextBmNo).split('|#|');
      const next = this.boardOVO.preBmNo && (this.boardOVO.preBmNo).split('|#|');

      if (next) {
        this.nextBoard.bmNo = next[0];
        this.nextBoard.bmTitle = next[1];
      }

      if (pre) {
        this.preBoard.bmNo = pre[0];
        this.preBoard.bmTitle = pre[1];
      }
    })

    axios.get(`board/reply/${this.currentBmNo}`)
    .then(r => {
      this.boardReplyList = r.data;
    })
  }

  // 게시글 정보 보기
  moreBoard(item: BoardOVO): void {
    this.boardBottomSheet.item = item;
    this.boardBottomSheet.opened = true;
  }

  // 게시글 수정
  modifyBoard(): void {
    this.$router.push({name: 'BoardForm', params: {bmNo: this.currentBmNo}})
  }

  // 게시글 삭제
  async deleteBoard() {
    this.boardBottomSheet.opened = false
    const opt = CommonUtils.baseConfirmOption;
    const res = await this.$confirm('게시글을 삭제하시겠어요?', opt);

    if(res) {
      axios.delete('/board', {params: {bmNo: this.boardBottomSheet.item.bmNo}})
      .then(r => {
        this.$router.push({name: 'Board'})
        this.$toast('글이 삭제되었어요')
      })
    }
  }

  // 파일 다운로드
  downloadAttachFile(item: FileMstVO) {
    const link = document.createElement('a')
    link.href = item.fmUrl;
    link.download = item.fmFileNm;
    link.click()
    URL.revokeObjectURL(link.href)
  }

  // 댓글 관련 더보기
  moreReply(item: BoardReplyOVO): void {
    this.replyBottomSheet.item = item;
    this.replyBottomSheet.opened = true;
  }

  // 댓글 작성 폼 열기
  async writeReplyForm() {
    if(this.isLogin() == false) {
      return;
    }

    if(this.replyBottomSheet.item.brNo) {
      this.currentReply.brNo = this.replyBottomSheet.item.brNo;
      this.currentReply.brContent = this.replyBottomSheet.item.brContent.replace(/<br>/g, '\r');
    }
    this.replyBottomSheet.opened = false;
    await (this.isReplyForm = true);

    this.$vuetify.goTo(9999, {duration: 500});
    (this.$refs.replyTextarea as HTMLInputElement).focus();
  }
  
  // 댓글 작성 폼 닫기
  closeReplyForm(): void {
    this.isReplyForm = false;
  }

  // 댓글 저장
  saveReply(): void {
    !this.currentReply.bmNo && (this.currentReply.bmNo = this.currentBmNo)
    axios.post('board/reply', this.currentReply)
    .then(r=>{
      this.boardReplyList = r.data;
      this.$toast('저장됐어요');
    })

    this.isReplyForm = false;
  }

  // 댓글 삭제
  async deleteReply() {
    const brNo = this.replyBottomSheet.item.brNo;
    const bmNo = this.replyBottomSheet.item.bmNo;
    
    this.replyBottomSheet.opened = false

    const opt = CommonUtils.baseConfirmOption;
    const res = await this.$confirm('댓글을 삭제하시겠어요?', opt);

    if(res) {
      axios.delete(`/board/reply`, {params: {brNo: brNo, bmNo: bmNo}})
      .then(r => {
        this.boardReplyList = r.data;
        this.$toast('댓글이 삭제되었어요')
      })
    }
  }

  // 게시글 신고하기
  async boardDeclar() {
    this.boardBottomSheet.opened = false;

    if(this.isLogin() == false) {
      return;
    }

    const opt = CommonUtils.baseConfirmOption;
    const res = await this.$confirm('게시글이 부적절한가요? 신고하시겠어요?', opt);

    if(res) {
      axios.post(`/board/declar`, this.boardOVO)
      .then(r => {
        this.$toast('신고됐어요')
      })
    }
  }

  // 댓글 신고하기
  async boardReplyDeclar() {
    if(this.replyBottomSheet.item.brNo) {
      this.currentReply.brNo = this.replyBottomSheet.item.brNo;
    }
    this.replyBottomSheet.opened = false;

    if(this.isLogin() == false) {
      return;
    }

    const opt = CommonUtils.baseConfirmOption;
    const res = await this.$confirm('댓글 내용이 부적절한가요? 신고하시겠어요?', opt);

    if(res) {
      axios.post(`/board/reply/declar`, this.currentReply)
      .then(r => {
        this.$toast('신고됐어요')
      })
    }
  }

  // 로그인 체크
  isLogin() {
    if(!this.member.mbrId) {
      this.$toast('로그인이 필요해요');
      return false;
    }
    return true;
  }

  // 댓글 입력 창 닫히면 데이터 초기화
  @Watch('isReplyForm')
  resetReplyFormData(e): void {
    if(e == true) return;
    this.currentReply = {} as BoardReplyOVO;
  }

  @Watch('currentBmNo')
  callBoard(): void {
    window.scrollTo(0,0);
    this.isReplyForm = false;
    this.getBoard(this.currentBmNo);
  }

  @Watch('replyBottomSheet.opened', {deep: true})
  opendReplySheet(e) {
    if(e == true) return;
    this.replyBottomSheet.item = {} as BoardReplyOVO;
  }

  mounted(): void {
    const list = this.$refs.list as Element;

    list.childNodes.forEach(r=> {
      console.log(r)
    })
  }

  created(): void {
    this.currentBmNo = this.bmNo;

    axios.get('/member')
    .then(r => {
      if(r.data) {
        this.member = r.data;
      } else {
        this.member = {} as MemberVO;
      }
    })
  }
}
